<template>
  <Modal v-model="modalVisible" :mask-closable="false" class="sl-modal-wrap" title="在线充值">
    <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="80">
      <FormItem label="车辆编号" prop="carNo">
        <Input v-model="form.carNo" />
      </FormItem>
      <FormItem label="命令" prop="cmd">
        <Input v-model="form.cmd" />
      </FormItem>
    </Form>
    <div slot="footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">{{buttonTitle}}</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  // left315 x top370  168x168
  data() {
    return {
      rules: {
        carNo: [{ required: true, message: '车辆编号不能为空', trigger: 'blur,change' }],
        cmd: [{ required: true, message: '命令不能为空', trigger: 'blur,change' }],
      },
      form: {
        carNo: null,
        cmd: null,
      },
      loading: false,
      modalVisible: false,
    }
  },

  computed: {

  },

  mounted() {},

  methods: {
    init(id) {
      if (id) {
        this.$refs['form'].resetFields()
        this.form.carNo = id
        this.modalVisible = true
      }
    },

    save() {
      let params = { ...this.form }
      this.loading = true
      this.$ui.confirm(this.$request.deviceCmd, `确定向  ${params.carNo} 下发 ${params.cmd}？`)(params).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
        } else {
          this.$Notice.error({
            title: '发生错误',
            desc: resp.msg,
          });
        }
        this.loading = false

      })

    },
    handleSubmit(name) {

      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    }

  }
}

</script>
